import {  IonRow, IonContent } from "@ionic/react"
import React, { useEffect, useState } from "react"
import Ae2Header from "../../components/AE2/Ae2Header"
import EnergyPerformanceMenu from "../../components/AE2/EnergyPerformance/EnergyPerformanceMenu"
import EnergyTargets from '../../components/AE2/EnergyPerformance/EnergyTargets'
import "./EnergyPerformance.css"
import BillsCostAvoidanceDashboard from "../../components/AE2/EnergyPerformance/BillsCostAvoidanceDashboard"
import MonthlyBuildingPerformanceTable from "../../components/AE2/AnalyticsSection/MonthlyBuildingPerformanceTable"
import CostAvoidanceData from "../../components/AE2/EnergyPerformance/CostAvoidanceData"
import Adjustments from "../../components/AE2/EnergyPerformance/Adjustments"
import IncentiveForecast from "../../components/AE2/EnergyPerformance/IncentiveForecast"
import AnnualEnergyTarget from "../../components/AE2/EnergyPerformance/AnnualEnergyTarget"
import { API_URL } from "../../actions/settings"
import AlphaInsightsHeader from "../../components/AE2/AlphaInsightsHeader"

async function getBuildingInfo(token: string,id: string) {
  return fetch(`${API_URL}/buildings/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            throw new Error(`Error fetching building info: ${res.status} ${res.statusText}`);
        }
      });
}


const EnergyPerformance: React.FC= () => {
    type Choices = 'home' | 'targets' | 'UtilityBills' | 'adjustments' | 'monthlyPerformance' | 'costAvoidanceData' | 'incentiveForecast' | 'annualTargets'
    const [ buildingInfo,setBuildingInfo] = useState<any>(null)
    const [selectedPage,setSelectedPage] = useState<Choices> ('targets')
    let params =  new URLSearchParams(window.location.search);
    const id = params.get('id')
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

    useEffect(()=>{
        const fetchBuildingInfo = async () => {
           const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
            if(id){
                const res = await getBuildingInfo(token,id)
                if(res){
                    setBuildingInfo(res.data)
                }
            }
        }
        
        fetchBuildingInfo();
    },[id])

    

    function selectPage(){
        switch(selectedPage){
            case 'targets':
                return <EnergyTargets />
            // case 'costAvoidance':
            //     return (<CostAvoidanceDashboard id={id} singleBuilding={true}/>)
            case 'adjustments':
                return (<Adjustments id={id}/>)
            case 'UtilityBills':
                return(<BillsCostAvoidanceDashboard id ={id} singleBuilding={true}/>)
            case 'monthlyPerformance':
                return(<MonthlyBuildingPerformanceTable type={'building'} building={id} />)
            case 'costAvoidanceData':
                return(<CostAvoidanceData building={id} />)
            case 'incentiveForecast':
                return(<IncentiveForecast building={id} />)
            case 'annualTargets':
                return(<AnnualEnergyTarget building={id} />)
            default:
                 return <div>Select Tab</div>                 

        }
    }

    return (
    <IonContent className= {newUI? 'energy-performance bg-main':'energy-performance main-background'}>
    {newUI? <AlphaInsightsHeader/> :<Ae2Header/>}

    <div>
        <IonRow  class="ion-justify-content-between button-bottom-right"><h1 className="main-heading">Energy Performance Details</h1>
        {/* <IonButton href={`/?id=${id}&sec=buildings`}> Building Page</IonButton> */}
        </IonRow>
        <IonRow><h3 className={newUI?'text-dark-blue':''} style={{padding:'0px',margin:'0px',marginLeft:'10px',marginBottom:'5px'}}>{buildingInfo ? <a style={{color:newUI?"black":"white"}} href={`/?id=${id}&sec=buildings`}>{buildingInfo.building_name} </a> : 'Loading Building...'}</h3></IonRow>
        <EnergyPerformanceMenu page={selectedPage} setPage={setSelectedPage}/>
    </div>
    {selectPage()}

    </IonContent>)
}

export default EnergyPerformance